import React from "react";
import { Elements } from "@stripe/react-stripe-js";

const PaymentMethodsTab = ({
  t,
  user,
  showDropdown,
  toggleDropdown,
  handleSetDefaultPayment,
  paymentToDelete,
  setPaymentToDelete,
  showDeletePaymentModal,
  setShowDeletePaymentModal,
  showDeletePaymentSuccess,
  setShowDeletePaymentSuccess,
  handleRemovePayment,
  showAddPaymentModal,
  setShowAddPaymentModal,
  paymentToUpdate,
  setPaymentToUpdate,
  newPayment,
  setNewPayment,
  showSelectUpdateCard,
  setShowSelectUpdateCard,
  stripePromise,
  AddPaymentForm,
  setUser,
}) => {
  // --- helpers to close modals ---
  const closeAddPayment = () => {
    setShowAddPaymentModal(false);
    setPaymentToUpdate(null);
  };
  const closeSelectUpdate = () => setShowSelectUpdateCard(false);
  const closeDeletePayment = () => setShowDeletePaymentModal(false);
  const closeDeleteSuccess = () => setShowDeletePaymentSuccess(false);

  // --- ESC to close any open modal ---
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (showAddPaymentModal) closeAddPayment();
      if (showSelectUpdateCard) closeSelectUpdate();
      if (showDeletePaymentModal) closeDeletePayment();
      if (showDeletePaymentSuccess) closeDeleteSuccess();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [
    showAddPaymentModal,
    showSelectUpdateCard,
    showDeletePaymentModal,
    showDeletePaymentSuccess,
  ]);

  return (
    <>
      <div className="tab-content">
        <h2 onClick={() => toggleDropdown("payment")}>
          {t("account.payment_methods")} {showDropdown ? "▼" : "▶"}
        </h2>

        {showDropdown &&
          user.paymentMethods.map((pm) => (
            <div key={pm.id} className="payment-card">
              <div className="payment-info-wrapper">
                {pm.type} **** {pm.last4}
                {pm.isDefault && (
                  <span className="default-badge">{t("account.default")}</span>
                )}
              </div>

              <div className="payment-actions">
                {!pm.isDefault && (
                  <button
                    className="set-default-btn"
                    onClick={() => handleSetDefaultPayment(pm.id)}
                  >
                    {t("account.set_default")}
                  </button>
                )}
                <button
                  className="delete-btn"
                  onClick={() => {
                    setPaymentToDelete(pm.id);
                    setShowDeletePaymentModal(true);
                  }}
                >
                  {t("account.remove_payment")}
                </button>
              </div>
            </div>
          ))}

        {user.paymentMethods.length > 0 && (
          <button
            className="update-btn"
            onClick={() => {
              if (user.paymentMethods.length === 1) {
                setPaymentToUpdate(user.paymentMethods[0]);
                setShowAddPaymentModal(true);
              } else {
                setShowSelectUpdateCard(true);
              }
            }}
          >
            {t("account.update_payment")}
          </button>
        )}

        <button
          className="add-btn"
          onClick={() => {
            setPaymentToUpdate(null);
            setShowAddPaymentModal(true);
          }}
        >
          {t("account.add_payment_method")}
        </button>
      </div>

      {/* Add/Update Payment (glass modal) */}
      {showAddPaymentModal && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeAddPayment(); // outside click
          }}
        >
          <div className="modal-card compact">
            <h3 className="modal-title">
              {paymentToUpdate
                ? t("account.update_payment_method_title")
                : t("account.add_payment_method")}
            </h3>

            <Elements stripe={stripePromise}>
              <AddPaymentForm
                t={t}
                isUpdating={!!paymentToUpdate}
                paymentToUpdate={paymentToUpdate}
                onSuccess={closeAddPayment}
                onCancel={closeAddPayment}
                newPayment={newPayment}
                setNewPayment={setNewPayment}
                setUser={setUser}
              />
            </Elements>
          </div>
        </div>
      )}

      {/* Select which saved card to update */}
      {showSelectUpdateCard && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeSelectUpdate();
          }}
        >
          <div className="modal-card">
            <h3 className="modal-title">{t("account.select_card_to_update")}</h3>

            {user.paymentMethods.map((pm) => (
              <div key={pm.id} style={{ marginBottom: 10 }}>
                {pm.type} **** {pm.last4}
                <button
                  className="primary-btn"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    setPaymentToUpdate(pm);
                    closeSelectUpdate();
                    setShowAddPaymentModal(true);
                  }}
                >
                  {t("account.update_this_card")}
                </button>
              </div>
            ))}

            <div className="modal-actions">
              <button className="secondary-btn" onClick={closeSelectUpdate}>
                {t("common.cancel")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete payment method */}
      {showDeletePaymentModal && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeDeletePayment();
          }}
        >
          <div className="modal-card">
            <h3 className="modal-title">
              {t("account.confirm_delete_payment_title")}
            </h3>
            <p>{t("account.confirm_delete_payment_message")}</p>

            <div className="modal-actions">
              <button className="danger-btn" onClick={handleRemovePayment}>
                {t("common.confirm")}
              </button>
              <button className="secondary-btn" onClick={closeDeletePayment}>
                {t("common.cancel")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete success */}
      {showDeletePaymentSuccess && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeDeleteSuccess();
          }}
        >
          <div className="modal-card">
            <h3 className="modal-title">{t("account.payment_delete_success")}</h3>
            <div className="modal-actions">
              <button className="primary-btn" onClick={closeDeleteSuccess}>
                {t("common.close")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentMethodsTab;